<template>
  <div class="search-input">
    <input @keyup.enter="searchBtn($event)" :value="searchValue" type="text" class="search" placeholder="Oyun Arayın"/>
  </div>
</template>

<script>
  export default{
      computed:{
        searchValue(){
          return this.$store.getters['casino/getSearch'];
        }
      },
      methods:{
        searchBtn(event){
          return this.$store.dispatch('casino/search', event.target.value);
        }
      }
  }
</script>